import { createElement } from '../../adapters/dom';

export interface LoadingTemplateOptions {
  title?: string;
  description?: string;
}

export function createLoadingTemplate(options: LoadingTemplateOptions = {}): HTMLDivElement {
  const wrapper = createElement('div', {
    className: 'cpw-screen cpw-screen-loading'
  }) as HTMLDivElement;

  const spinner = createElement('div', {
    className: 'cpw-spinner',
    attributes: {
      'aria-hidden': 'true'
    }
  });

  const title = createElement('h3', {
    className: 'cpw-title',
    textContent: options.title ?? 'Загрузка'
  });

  const description = createElement('p', {
    className: 'cpw-text',
    textContent: options.description ?? 'Пожалуйста, подождите...'
  });

  wrapper.append(spinner, title, description);

  return wrapper;
}